import { useAuthContext } from './AuthProvider';
export const useAuth = () => useAuthContext();
